import React from "react";
import { useLocation, Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { getLangFromPath, buildPathWithLang } from '../i18n/lang';

function Sidebar() {
  const loc = useLocation();
  const { t } = useTranslation('common');
  const currentLang = getLangFromPath(loc.pathname);
  const link = (path) => buildPathWithLang(currentLang, path);

  const path = (() => {
    const raw = ((loc.pathname || "/").replace(/\/+$/, "")) || "/";
    const parts = raw.split('/').filter(Boolean);
    const first = (parts[0] || '').toLowerCase();
    if (parts.length && ['uk', 'en', 'it', 'fr'].includes(first)) {

      parts.shift();
      if (!parts.length) return "/";
      return `/${parts.join('/')}`.replace(/\/+$/, "") || "/";
    }
    return raw;
  })();

  const sidebarSections = [
    {
      titleKey: "",
      items: [
        { nameKey: "nav.home", path: "/", bold: true },
      ],
    },
    {
      titleKey: "nav.statistics._",
      bold: true,
      titleLink: "/service/stats",
      items: [
        { nameKey: "nav.statistics.settings", path: "/cabinet/radio" },
        { nameKey: "nav.statistics.active_listeners", path: "/service/live" },
        { nameKey: "nav.statistics.listeners", path: "/service/listeners" },
        { nameKey: "nav.statistics.user_agent", path: "/service/user-agent" },
        { nameKey: "nav.statistics.geo", path: "/service/geo" },
        { nameKey: "nav.statistics.peak_loads", path: "/service/peak" },
        { nameKey: "nav.statistics.aha", path: "/service/aha" },
        { nameKey: "nav.statistics.tsl", path: "/service/tsl" },
        { nameKey: "nav.statistics.tlh", path: "/service/tlh" },
        { nameKey: "nav.statistics.new_listeners", path: "/service/new-listeners" },
        { nameKey: "nav.statistics.adr", path: "/service/adr" },
        { nameKey: "nav.statistics.ads_reach", path: "/service/ads-reach" },
        { nameKey: "nav.statistics.reach", path: "/service/reach" },
        { nameKey: "nav.statistics.retention", path: "/service/retention" },
        { nameKey: "nav.statistics.loyalty", path: "/service/loyalty" },
        { nameKey: "nav.statistics.top40", path: "/service/top40" },
        { nameKey: "nav.statistics.ltr", path: "/service/ltr" },
        { nameKey: "nav.statistics.quartiles_ltr", path: "/service/quartiles-ltr" },
        { nameKey: "nav.statistics.ads", path: "/service/ads" },
      ],
    },
    {
      titleKey: "nav.silence._",
      bold: true,
      titleLink: "/service/silence",
      items: [
        { nameKey: "nav.silence.settings", path: "/service/silence/settings" },
        { nameKey: "nav.silence.levels", path: "/service/silence/levels" },
      ],
    },
    {
      titleKey: "nav.cabinet._",
      bold: true,
      items: [
        { nameKey: "nav.cabinet.my_data", path: "/profile" },
        { nameKey: "nav.cabinet.users", path: "/users" },
        { nameKey: "nav.cabinet.live_wall", path: "/cabinet/live-wall" },
        { nameKey: "nav.cabinet.schedule_import", path: "/cabinet/schedule-import" },
        { nameKey: "nav.cabinet.radio_portal", path: "/cabinet/radio-portal" },
        { nameKey: "nav.cabinet.billing", path: "/billing", hidden: true },
      ],
    },
  ];

  return (
    <aside
      style={{
        width: 260,
        background: "#efefef",
        padding: "32px 30px 32px 38px",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        borderRight: "1px solid #ddd"
      }}
    >
      <div style={{ width: "100%" }}>
        {sidebarSections.map((section, idx) => (
          <div key={idx} style={{ marginBottom: 16 }}>
            {section.titleKey && (() => {
              const titlePath = ((section.titleLink || "").replace(/\/+$/, "")) || "/";
              const isTitleActive = !!section.titleLink && path === titlePath;
              const titleNode = (
                <div
                  style={{
                    fontWeight: section.bold ? 700 : 400,
                    fontSize: 16,
                    margin: "16px 0 6px 0",
                    color: isTitleActive ? "rgb(0,110,69)" : "#222",
                    textAlign: "left",
                  }}
                >
                  {t(section.titleKey)}
                </div>
              );
              return section.titleLink ? (
                <Link to={link(section.titleLink)} style={{ textDecoration: "none" }}>
                  {titleNode}
                </Link>
              ) : (
                titleNode
              );
            })()}
            <div style={{ marginLeft: section.titleKey ? 14 : 0 }}>
              {section.items && section.items.map((item, subIdx) => {
                if (item.hidden) return null;
                const itemPath = ((item.path || "").replace(/\/+$/, "")) || "/";
                const isActive = path === itemPath;
                const text = item.label || (item.nameKey ? t(item.nameKey) : "");
                return (
                  <div key={subIdx} style={{ margin: "2px 0" }}>
                    <Link
                      to={link(item.path)}
                      style={{
                        color: isActive ? "rgb(0,110,69)" : (item.color || "#222"),
                        textDecoration: "none",
                        fontWeight: isActive ? 700 : (item.bold ? 700 : 400),
                        fontSize: 16,
                        display: "block",
                        textAlign: "left",
                        marginBottom: 2
                      }}
                    >
                      {text}
                    </Link>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </aside>
  );
}

export default Sidebar;
